<template>
  <div class="text-center py-24 text-red-500 dark:text-slate-400">
    <p>No tiene permisos para acceder a este recurso, favor de contactarse con su administrador</p>
  </div>
</template>
